import { mutatorAction } from 'satcheljs';
import { ResortDto } from '../../services/openapi/models/ResortDto';
import { getResortStore } from '../stores/ResortStore';

export const setResortList = mutatorAction('setResortList', (resortList: ResortDto[]) => {
  getResortStore().resortList = resortList;
});
